// extracted by mini-css-extract-plugin
export default {"page":"ydKxlXPVf_BiBhMNUCrQ"};